import { Button } from '@material-ui/core';
import axios from 'axios';
import React, { Component } from 'react';
import TransferList from './TransferList';
import { handlePdf } from '../../../utils/AxiosUtil';

class Owing extends Component {
    state = {
        owings: [],
        wiredOwingsWithoutTransaction: null,
        result: []
    };

    componentDidMount() {
        this.callApi()
            .then(res => this.enrich(res.data))
            .catch(err => console.log(err));
    }

    refreshState() {
        this.callApi()
            .then(res => this.enrich(res.data))
            .catch(err => console.log(err));
    }

    enrich = (data) => {
        this.setState({ owings: data.owings, wiredOwingsWithoutTransaction: data.wiredOwingsWithoutTransaction })
    }

    callApi = async () => {
        const response = await axios.get('/api/owings');
        if (response.status !== 200) throw Error(response.message);
        return response;
    };

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/owing';
        const requestObject = {
            payables: this.state.result
        };
        handlePdf(path, requestObject, this);
    };

    handleSuccess = (response) => {
        const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
    };

    setResult = (data) => {
        const ids = [];
        if (data) {
            /* eslint-disable array-callback-return */
            data.map(row => {
                ids.push({
                    privateId: row.privateId,
                    payableType: row.payableType
                })
            })
        }
        this.setState({ result: ids });
    }

    render() {
        return (
            <div className="Owing">
                <section id="main-content">
                    <div className="content-header">
                        <div className="flex-container">
                            <div className="title-actions">
                                <div className="title-data">
                                    <h1>Utalandó</h1>
                                </div>
                                <div className="actions">
                                    <Button variant="contained" color="primary" component="span" onClick={this.handleSubmit}>
                                        PDF
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="content">
                        <TransferList left={this.state.wiredOwingsWithoutTransaction} right={this.state.owings} setResult={this.setResult} />
                    </div>
                </section>
            </div>
        );
    }
}

export default Owing;
